/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState } from 'react';

import Companyprofile from './PreCompanyprofile';
import { userContext } from '../../../../contextProvider/Authentication';
import axiosInstance from '../../../../services/AxiosInstance';
import SimpleReactValidator from 'simple-react-validator';
import { handleDatePicker } from '../../../../Functions/apis';
import swal from 'sweetalert';

function ConCompanyprofile() {
    const { user, setReload } = useContext(userContext);
    const [input, setInput] = useState({})
    const [profile, setProfile] = useState({})
    const [, forceUpdate] = useState()
    const simpleValidator = useRef(new SimpleReactValidator());
    let url = "institution/"

    useEffect(() => {
        getData();
    }, [user])

    const getData = () => {
        axiosInstance(url, { method: "GET" })
            .then(res => {
                var valu = res?.data?.results?.[0];
                setProfile(valu);
                if (valu) {
                    var db = valu.founded_date?.split("-");
                    valu["founded_date"] = `${db[2]}-${db[1]}-${db[0]}`;
                    setInput(Object.assign({}, user, valu));
                }
            })
            .catch(err => swal("", Object.values(err.response.data), "error", { button: "Ok!", }))
    }

    const handleInput = (e, name, type) => {
        if (['dropdown', 'phone'].includes(type)) {
            setInput({ ...input, [name]: e });
            if (name === 'country') setInput({ ...input, [name]: e, 'state': {}, 'city': {} })
            if (name === 'state') setInput({ ...input, [name]: e, 'city': {} })
        }
        else setInput({ ...input, [e.target.name]: e.target.value })
    }

    const handleSubmit = async () => {
        let formValid = simpleValidator.current.allValid();
        if (!formValid) {
            simpleValidator.current.showMessages();
            forceUpdate(1);
        } else {
            let lurl = profile?.id ? `${url}${profile?.id}/` : url;
            let method = profile?.id ? "PUT" : "POST";
            let linput = input;
            linput["city"] = linput?.city?.id;
            linput["country"] = linput?.country?.id;
            linput["founded_date"] = handleDatePicker(new Date(linput?.founded_date));
            linput["state"] = linput?.state?.id;
            let can_name = { "first_name": linput?.first_name, "last_name": linput?.last_name };
            await axiosInstance(`user/${user?.id}/`, { method: "PATCH", data: can_name })
            axiosInstance(
                lurl, {
                method: method,
                data: linput
            }).then(res => {
                getData();
                setReload(res?.headers?.date);
                swal("", "Updated successfully", "success", { button: "Ok!", })
            }).catch(err => {
                swal("", Object.values(err.response?.data).join(", "), "error", { button: "Ok!", })
            })

        }
    }

    var data = {
        input,
        handleInput,
        handleSubmit,
        simpleValidator
    }

    return (
        <>
            <Companyprofile data={data} />
        </>
    );
}

export default ConCompanyprofile;